<template>
  <Layout>
    <div class="card top-draft">
      <div class="">
        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.content"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              :options="statusOptions"
              type="text"
            ></b-form-select>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.verifyState"
              class="form-select"
              :options="stateList"
              type="text"
            ></b-form-select>
          </div>
          <el-button
            v-if="power['添加']"
            size="mini"
            @click="openCreateModal()"
            type="primary"
            icon="el-icon-plus"
            >添加</el-button
          >
        </div>

        <div class="col-lg-12">
          <div class="table-responsive" v-loading="tableLoading">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">圈子名称</th>
                  <th scope="col" class="w-300px">图片</th>
                  <th scope="col" class="w-300px">关联媒体号</th>
                  <th scope="col">关注人数</th>
                  <th scope="col">阅读数</th>
                  <th scope="col">发帖数</th>
                  <th scope="col">审核状态</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建时间</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id || "--" }}</td>

                  <td class="white-inherit">{{ item.name || "--" }}</td>
                  <td>
                    <img
                      :src="item.cover"
                      v-if="item.cover"
                      style="width: 50px; cursor: pointer"
                      @click="showImg(item.cover)"
                    /><span v-else>--</span>
                  </td>
                  <td class="white-inherit">
                    {{ item.mediaName || "--" }}
                  </td>
                  <td>
                    {{ item.memberNum
                    }}<span v-if="item.operateFollowNum">
                      <br />({{
                        (Number(item.memberNum) || 0) +
                          (Number(item.operateFollowNum) || 0)
                      }})</span
                    >
                  </td>
                  <td>{{ item.viewNum || "--" }}</td>
                  <td>{{ item.postNum || "--" }}</td>
                  <td>{{ showState(item.verifyState) }}</td>
                  <td>
                    <el-tooltip
                      v-if="power['显示/隐藏']"
                      :content="
                        item.showDisabled == 0 ? '点击隐藏' : '点击显示'
                      "
                    >
                      <span
                        @click="changeState(item)"
                        v-if="item.showDisabled == 0"
                        class="dsply-fix status-open"
                        ><i></i>显示</span
                      >
                      <span
                        @click="changeState(item)"
                        v-if="item.showDisabled == 1"
                        class="dsply-fix status-off"
                        ><i></i>隐藏</span
                      >
                    </el-tooltip>
                    <el-tooltip v-if="!power['显示/隐藏']">
                      <span
                        v-if="item.showDisabled == 0"
                        class="dsply-fix status-open"
                        ><i></i>显示</span
                      >
                      <span
                        v-if="item.showDisabled == 1"
                        class="dsply-fix status-off"
                        ><i></i>隐藏</span
                      >
                    </el-tooltip>
                  </td>
                  <td>{{ item.createAt || "--" }}</td>
                  <td>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>

                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toContent(item)"
                    >
                      内容管理
                    </button>
                    <button
                      v-if="item.verifyState == 0"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="batchRevert(item)"
                    >
                      撤销审核
                    </button>
                    <button
                      v-if="power['移除']"
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      删除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!items || !items[0]" class="xb-table-noData">
              <span v-if="!tableLoading && !items[0]">暂无数据</span>
            </div>
          </div>
          <pagination
            class="bath_r_20"
            :isBatch="true"
            :total="pageTotal"
            :batchs="batchs"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            @pageCallback="pageCallback"
            ref="page"
          ></pagination>
        </div>
      </div>

      <el-dialog
        :title="detailTitle"
        :visible.sync="detailModal"
        class="top-draft-dialog"
        append-to-body
        :before-close="closeCreateModal"
        width="800px"
      >
        <div class="col-12 px-5">
          <div class="col-12 pb-4 flex-align-center">
            <div class="col-2 text-end pe-3"><span must>*</span>圈子名称</div>
            <div class="col-10">
              <b-input class="col-12" v-model="name"></b-input>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>图片</div>
            <div class="col-10">
              <image-upload size="1:1" v-model="cover"></image-upload>
              <div style="color: #aaa; margin-top: 5px">
                图片比例 1:1，建议尺寸 600 * 600 px，建议文件小于10MB
              </div>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>圈子简介</div>
            <div class="col-10">
              <b-form-textarea rows="3" v-model="description"></b-form-textarea>
            </div>
          </div>

          <!-- <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>媒体号</div>
            <div class="col-10">
              <span class="pe-2" v-if="mediaName !== ''">{{ mediaName }}</span>
              <b-button
                variant="primary"
                class="px-3 py-1"
                pill
                @click="selectMedia"
                >选择</b-button
              >
            </div>
          </div> -->
          <div class="col-12 pb-4 flex-align-center">
            <div class="col-2 text-end pe-3">运营</div>
            <div class="col-10 flex-align-center">
              <span>关注数：</span>
              <b-input
                style="width: 100px"
                v-model="operateFollowNum"
              ></b-input>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3">状态</div>
            <div class="col-10">
              <b-form-radio-group plain v-model="showDisabled">
                <b-form-radio :value="0">显示</b-form-radio>
                <b-form-radio :value="1">隐藏</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>

        <div class="xb-footer">
          <b-button
            variant="outline-primary"
            @click="detailModal = false"
            style="margin-right: 20px"
            class="btn-sm"
            >取消</b-button
          ><b-button variant="primary" class="btn-sm" @click="saveGroup"
            >确认</b-button
          >
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import imageUpload from "@/components/imageUpload";
import groupApi from "@/server/api/group.js";
import { getOperateNum } from "@/util/fun.js";
import { changeList, replaceImgUrl } from "@/util/fun.js";
import { addCache, updateCache } from "@/util/localAche.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    imageUpload,
  },

  data() {
    return {
      id: undefined,
      pageTotal: 0,
      page: 1,
      pageSize: 10,
      detailTitle: "新建",
      power: "",
      choiceListIds: [], //当前所选择的id
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        verifyState: "", //审核状态，有来源时不传,0-未审核,1-通过,2-未通过
        content: "",
        showState: "",
      },
      items: [],
      statusOptions: [
        { text: "筛选状态", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "显示", value: 0 },
        { text: "隐藏", value: 1 },
        // { text: "运营用户", value: "3" },
      ],
      stateList: [
        { text: "全部状态", value: "" },
        { text: "待审核", value: 0 },
        { text: "通过", value: 1 },
        { text: "驳回", value: 2 },
        { text: "草稿", value: 3 },
      ],
      showDetail: false,
      dialogItem: {},
      detailModal: false,
      batchs: [
        { text: "批量操作", value: "0" },
        // { text: "撤销审核", value: "撤销审核" },

        // { text: "显示", value: "显示" },
        // { text: "隐藏", value: "隐藏" },
        // { text: "删除", value: "删除" },
      ],
      name: "",
      description: "",
      mediaId: undefined,
      mediaName: "测试",
      showDisabled: 0, //显示状态 0-显示,1不显示
      operateFollowNum: "",
      tableLoading: false,
      cover: "",
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.items.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (["/groupContent"].indexOf(from.path) == -1) {
      console.log("清空列表缓存");
      //清空列表数据
      updateCache("group-list", { list: "" });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/groupContent"].indexOf(to.path) == -1) {
      console.log("清空列表缓存");
      //清空列表数据
      updateCache("group-list", { list: "" });
    }
    next();
  },
  beforeMount() {},
  beforeDestroy() {
    this.addCache("group-list", {
      list: this.items,
      pageParams: this.pageParams,
      pageTotal: this.pageTotal,
    });
  },
  created() {
    this.power = this.utils.currentPower("创作平台-圈子管理");
    if (this.power["显示/隐藏"]) {
      this.batchs.push({ text: "显示", value: "显示" });
      this.batchs.push({ text: "隐藏", value: "隐藏" });
    }
    if (this.power["移除"]) {
      this.batchs.push({ text: "删除", value: "删除" });
    }
    this.power = this.utils.currentPower("创作平台-圈子管理");
    this.mediaId = JSON.parse(localStorage.chosedMedia).id;
    // if (this.power["审核"]) {
    //   this.batchs.push({ text: "撤销审核", value: "撤销审核" });
    // }
    let obj = this.getCache("group-list");
    if (obj && obj.list && obj.list[0]) {
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      this.pageParams = obj.pageParams;
    } else {
      this.getList();
    }
  },

  methods: {
    saveGroup() {
      if (!this.name) {
        this.warning("名称未填写");
        return;
      }
      if (!this.description) {
        this.warning("简介未填写");
        return;
      }
      // if (!this.mediaId) {
      //   this.warning("未选择媒体号");
      //   return;
      // }
      if (!this.cover) {
        this.warning("请上传封面图");
        return;
      }
      let operateFollowNum = getOperateNum(this.operateFollowNum, "follow");
      if (typeof operateFollowNum == "string") {
        this.warning(operateFollowNum);
        return;
      }
      let params = {
        name: this.name,
        description: this.description,
        mediaId: this.mediaId,
        cover: this.cover,
        showDisabled: this.showDisabled,
        operateFollowNum,
      };
      if (this.id !== undefined) {
        this.confirm("确认保存圈子设置并提交审核吗？ ", () => {
          params.id = this.id;
          console.log("保存参数", params);
          groupApi.update(params).then((res) => {
            if (res.code === 0) {
              this.success("更新成功！");
              this.getList(false);
              this.detailModal = false;
            } else {
              this.warning(res.msg);
              console.log(res);
            }
          });
        });
      } else {
        this.confirm("确认创建圈子并提交审核吗？", () => {
          groupApi.create(params).then((res) => {
            if (res.code === 0) {
              this.success("创建成功！");
              this.getList(false);
              this.detailModal = false;
            } else {
              this.warning(res.msg);
              console.log(res);
            }
          });
        });
      }
    },
    selectMedia() {
      this.$refs.media.showModel();
    },
    //给组件的回调
    pageCallback(obj) {
      console.log(obj);
      if (obj.code == "media") {
        this.mediaId = obj.item.id;
        this.mediaName = obj.item.name;
        return;
      }
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds);
        if (obj.batch == "删除") {
          if (this.choiceListIds.length) {
            this.remove();
          } else {
            this.warning("请选择要删除的内容");
            return;
          }
        }
        if (obj.batch == "显示") {
          if (this.choiceListIds.length) {
            this.confirm("确认把已选内容更为显示状态？", () => {
              this.changeStatus(true);
            });
          } else {
            this.warning("请选择要更改的内容");
            return;
          }
        }
        if (obj.batch == "隐藏") {
          if (this.choiceListIds.length) {
            this.confirm("确认把已选内容更为隐藏状态？", () => {
              this.changeStatus(false);
            });
          } else {
            this.warning("请选择要更改的内容");
            return;
          }
        }
        if (obj.batch == "撤销审核") {
          if (this.choiceListIds.length) {
            this.confirm("确认撤销？", () => {
              let params = {
                id: this.choiceListIds,
                state: 3,
                reason: "",
              };
              groupApi.examineBatch(params).then((res) => {
                if (res.code == 0) {
                  this.success("撤销成功！");
                  this.getList();
                  this.choiceListIds = [];
                }
              });
            });
            // this.confirm("确认把已选内容更为隐藏状态？", () => {
            //   this.changeStatus(false);
            // });
          } else {
            this.warning("请选择要撤销的内容");
            return;
          }
        }
      }
    },
    changeState(item) {
      let msg = item.showDisabled ? "确认显示？" : "确认隐藏？";
      this.confirm(msg, () => {
        this.changeStatus(item);
      });
    },
    //更改状态，如果judge存在则item为对象，否则为改为显示或不显示
    changeStatus(item) {
      let params = {};
      if (typeof item !== "boolean") {
        let arr = [];
        arr.push(item.id);
        params.id = arr;
        params.state = item.showDisabled ? 0 : 1;
      } else {
        params.id = this.choiceListIds;
        params.state = item ? 0 : 1;
      }
      groupApi.statusBatch(params).then((res) => {
        if (res.code === 0) {
          if (typeof item == "boolean") {
            this.items = changeList(
              "changeAttribute",
              this.items,
              this.choiceListIds,
              {
                showDisabled: item ? 0 : 1,
              }
            );
            this.choiceListIds = [];
          } else {
            item.showDisabled = item.showDisabled ? 0 : 1;
          }
          this.success("更改成功！");
          // this.getList();直接改数据
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },

    //删除
    remove(item) {
      let params = {};
      if (item) {
        params.ids = [item.id];
      } else {
        params.ids = this.choiceListIds;
      }
      console.log("删除的参数", params);
      groupApi.deleteBatch(params).then((res) => {
        if (res.code === 0) {
          this.success("删除成功！");
          // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
          if (this.items.length == params.ids.length) {
            this.getList();
          } else {
            this.pageTotal -= params.ids.length;
            this.items = changeList("delete", this.items, params.ids, "id");
            if (!item) {
              this.choiceListIds = [];
            }
          }
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.verifyState = "";
      this.pageParams.content = "";
      this.getList();
    },

    // 列表全选
    checkedAll(val) {
      if (val) {
        this.choiceListIds = this.items.map((item) => item.id);
      } else {
        this.choiceListIds = [];
      }
    },

    handleClose() {
      this.showDetail = false;
    },

    // 创建
    openCreateModal() {
      this.id = undefined;
      this.detailTitle = "新建";
      this.dataInit();
      this.detailModal = true;
    },
    closeCreateModal() {
      this.detailModal = false;
    },
    dataInit() {
      this.id = undefined;
      this.name = "";
      this.description = "";
      this.mediaId = undefined;
      this.mediaName = "";
      this.cover = "";
      this.operateFollowNum = "";
      this.showDisabled = 0;
      if (this.$refs.image) {
        this.$refs.image.setImageUrl("");
      }
    },
    // 编辑
    toDetail(item) {
      console.log("编辑", item);
      this.detailTitle = "编辑";
      this.dataInit();
      this.id = item.id;
      this.name = item.name;
      this.description = item.desc;
      this.mediaName = item.mediaName;
      this.mediaId = item.mediaId;
      this.operateFollowNum = item.operateFollowNum || 0;
      this.detailModal = true;
      this.cover = item.cover;
    },
    toContent(item) {
      this.$router.push({
        name: "groupContent",
        query: { id: item.id },
      });
    },
    //获取圈子列表
    getList(showLoading) {
      let params = this.another(this.pageParams);
      params.mediaId = this.mediaId;
      this.cleanObj(params);
      if (showLoading !== false) {
        this.items = [];
        this.tableLoading = true;
      }
      console.log("圈子搜索参数", params);
      groupApi.list(params).then((res) => {
        console.log("圈子列表", res);
        if (res.code === 0) {
          this.tableLoading = false;
          this.items = replaceImgUrl(res.data.items, this.items);
          this.pageTotal = res.data.total;
        }
      });
    },
    //显示审核状态
    showState(state) {
      if (state === 0) {
        return "待审核";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state === 3) {
        return "草稿";
      }
    },
    //显示图片原图
    showImg(url) {
      console.log("显示图片");
      // this.$refs.imgDetail.showModal(url);
      this.ShowImg(url);
    },
    //撤销审核
    batchRevert(item) {
      console.log(item);
      this.confirm("确认撤销审核？", () => {
        let params = { id: [item.id], state: 3, verifyId: item.verifyId };
        groupApi.examineBatch(params).then((res) => {
          if (res.code == 0) {
            this.items = changeList("changeAttribute", this.items, [item.id], {
              verifyState: 3,
            });
            this.success("撤销成功！");
            // this.getList();
          }
        });
      });
    },
  },
};
</script>
